import multilang from './multilang'

export default
{
    multilang
};
